// React imports.
import React, { Component } from "react";

// App imports.
import Assessment3bMainTable from "./Assessment3bMainTable"
import Assessment3bTopParagraph from "./Assessment3bTopParagraph";
import Assessment3bQuestions from "./Assessment3bQuestions";
import Assessment3bDownloadCSV from "./Assessment3bDownloadCSV";
import TableLegendLeft from "./TableLegendLeft";

import { Assessment3bStepsEnum } from "../state";
import { Assessment3bDataReceivedStatusEnum } from "../state";

//EnterDataNumHouseholds=0,
//NumHouseholdsMainHeatData=1,
//NumHouseholdsElectricData=2,
//ResultsOverview=3,
//AccountMatchingNaturalGas=4,
//AccountMatchingFuelOil=5,
//AccountMatchingPropane=6,
//ActionPlanSummary=7,

const Assessment3b = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment3bStepsEnum.EnterDataNumHouseholds &&
          <div>
              <p><strong><u>Step 1:</u>  Enter the Number of Assisted Households by Fuel Type</strong></p>
              <p>In order to report a household under Section V, Part B, Line 1 of your Performance Data  
              Form (Module 2) you need to have collected 12 consecutive months of billing data  
              from&nbsp;<em>both</em>&nbsp;their main heating fuel provider&nbsp;<em>and</em>&nbsp;their  
              baseload electricity provider. Assessment #3B helps you determine if you were unable to  
              report the data for a large number of households because you were only able to collect  
              one but not both of these types of expenditure data.</p>

              <p><strong>Please establish a baseline for comparison by entering the number of  
              LIHEAP-assisted clients that use each type of non-electric main heating fuel in the  
              year you are evaluating in the table below.</strong></p>
              {state.HouseholdsAssisted.numberOfAssistedHouseholdsElectric != null
                && <p><strong>Note:</strong>&nbsp;You report the total number of LIHEAP-assisted households  
                by fuel type in your annual Performance Measures Form. Since you are evaluating a  
                program year for which the data have already been processed, we have auto-populated  
                this information in the table below.</p>}
              {state.HouseholdsAssisted.numberOfAssistedHouseholdsElectric == null
                && <p>
                  You report the total number of LIHEAP-assisted households by fuel type in your annual 
                  Performance Measures Form. However, since you are evaluating a program year for which 
                  the data have NOT already been processed, you must enter the necessary information 
                  from Section V, Line A of your Performance Data Form.                     
              </p>}

              <Assessment3bMainTable  fieldChangeHandler={state.assessment3bFieldChangeHandler} holder={state.Assessment3bFuelTypesStatus} step={state.Assessment3bSteps[state.CurrentAssessementStepIndex]} state={state} />
              <TableLegendLeft />
          </div>
          }

          {(state.CurrentAssessementStepIndex == Assessment3bStepsEnum.NumHouseholdsBothHeatAndElectric)
              &&
              <div>
                  <p><strong><u>Step 2:</u>    Number of Assisted Households with 12 Months of Consecutive for Both Main Heating and Baseload Electric</strong></p>
                  <p>In order to report households on your Performance Data Form Module 2, you need to  
                  have collected <em>both </em>12 months of their main heating fuel  
                  data <em>and </em>12 months of their electric baseload data.</p>
                  <p><strong>Please enter the number of households for whom you collected  
                  both 12 months of main heating fuel expenditure data and 12 months of  
                  electric baseload data for each type of assisted household in the table  
                  below. </strong></p>
                  <p><strong>Note: </strong>You report this information in Section V,  
                  Part B Line 1 of your Performance Data Form (Module 2). If you are  
                  evaluation a year for which data has already been submitted to the  
                  Data Warehouse, then this information will be auto populated. If you  
                  are evaluating a year for which data is still being processed, then  
                  you will need to provide these numbers from your own records.</p>
                  <Assessment3bMainTable  fieldChangeHandler={state.assessment3bFieldChangeHandler} holder={state.Assessment3bFuelTypesStatus} step={state.Assessment3bSteps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
              </div>
          }

          {(state.CurrentAssessementStepIndex == Assessment3bStepsEnum.NumHouseholdsMainHeatData)
              &&
              <div>
                  <p><strong><u>Step 3:</u>    Number of Households with 12 Months of Main Heating Fuel</strong></p>
                  <p>In order to report households on your Performance Data Form Module 2, you need to  
                  have collected&nbsp;<em>both</em>&nbsp;12 months of their main heating fuel  
                  data&nbsp;<em>and</em>&nbsp;12 months of their electric baseload data. If you  
                  have collected only one type of data from a large percentage of your households,  
                  this indicates that you may have an error in your data collection, recording, or  
                  processing process. Providing the number of households for whom you have 12  
                  months of each type of data will allow you to determine whether this is the  
                  case.</p>
                  <p><strong>Please provide the number of assisted households for whom you have collected  
                  12 months of main heating fuel expenditure data regardless of whether you have  
                  collected electric baseload data on that household in the table below. Include  
                  any households where you have either:</strong></p>
                  <ol>
                      <li><strong>Complete heating fuel data and complete electric data</strong></li>
                      <li><strong>Complete heating fuel data and incomplete electric data</strong></li>
                      <li><strong>Complete heating fuel data and no electric data.</strong></li>
                  </ol>
                  <p><strong>Note:</strong>&nbsp;You do not report the number of assisted households for whom  
                  you have collected 12 months of main heating data but do not have 12 months  
                  of electric data on your Performance Data Form. So, you will have to ask your  
                  IT staff to generate those numbers.</p>
                  <Assessment3bMainTable  fieldChangeHandler={state.assessment3bFieldChangeHandler} holder={state.Assessment3bFuelTypesStatus} step={state.Assessment3bSteps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <br />
              </div>
          }

          {(state.CurrentAssessementStepIndex == Assessment3bStepsEnum.NumHouseholdsElectricData)
              &&
              <div>
                  <p><strong><u>Step 4:</u>   Number of Households with 12 Months of Electric Baseload Data</strong></p>
                  <p>In order to report households on your Performance Data Form Module 2, you  
                  need to have collected&nbsp;<em>both</em>&nbsp;12 months of their main  
                  heating fuel data&nbsp;<em>and</em>&nbsp;12 months of their electric  
                  baseload data. If you have collected only one type of data from a large  
                  percentage of your households, this indicates that you may have an error  
                  in your data collection, recording, or processing process. Providing the  
                  number of households for whom you have 12 months of each type of data will  
                  allow you to determine whether this is the case.</p>
                  <p><strong>Please provide the number of assisted households for whom you have  
                  collected 12 months of electric baseload expenditure  
                  data&nbsp;<em>regardless</em>&nbsp;of whether you have collected main  
                  heating fuel data on that household in the table below. Include any  
                  households where you have either:</strong></p>
                  <ol>
                      <li><strong>Complete electric data and complete heating fuel data</strong></li>
                      <li><strong>Complete electric data and incomplete heating fuel data</strong></li>
                      <li><strong>Complete electric data and no heating fuel data.</strong></li>
                  </ol>
                  <p><strong>Note:</strong>&nbsp;You do not report the number of assisted households for  
                  whom you have collected 12 months of electric baseload data but do not  
                  have 12 months of heating data on your Performance Data Form. So, you  
                  will have to ask your IT staff to generate those numbers.</p>
                  <Assessment3bMainTable  fieldChangeHandler={state.assessment3bFieldChangeHandler} holder={state.Assessment3bFuelTypesStatus} step={state.Assessment3bSteps[state.CurrentAssessementStepIndex]} state={state} />
                  <TableLegendLeft />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3bStepsEnum.ResultsOverview &&
              <div>
                  <p>
                      <strong><u>Step 5:</u>  Results Overview</strong>
                  </p>
                  <p>Now that you have provided the necessary information, we can check to see  
                  if you have main heating and electric billing data for enough households.  
                  The table below shows an overview of your results. Each fuel type will  
                  be flagged for a potential data reliability issue if:</p>
                  <ol>
                      <li>You received heating data for less than 50% of your Electric  
	                  and Natural Gas households or less than 20% of your Fuel Oil  
	                  and propane households.</li>
                      <li>You received electric data for less than 50% of your Electric  
	                  and Natural Gas households or less than 20% of your Fuel Oil  
	                  and propane households.</li>
                      <li>You received a combination of BOTH electric baseload and main  
	                  heat billing data from less than 50% of Natural Gas households  
	                  or less than 20% for Fuel Oil and Propane households.</li>
                  </ol>
                  <p><span>These results are explored more thoroughly for each fuel type in Steps 5a-5c.</span></p>
                  <Assessment3bMainTable  fieldChangeHandler={state.assessment3bFieldChangeHandler}
                                          holder={state.Assessment3bFuelTypesStatus}
                                          step={state.Assessment3bSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3bStepsEnum.AccountMatchingNaturalGas &&
              <div>
                  <p>
                      <strong><u>Step 5a:</u>  Results –  Natural Gas Households</strong>
                  </p>

                  <Assessment3bTopParagraph state={state}  fuelType={state.Assessment3bFuelTypesStatus.NaturalGas} />
                  <Assessment3bMainTable  fieldChangeHandler={state.assessment3bFieldChangeHandler}
                                          holder={state.Assessment3bFuelTypesStatus}
                                          step={state.Assessment3bSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment3bQuestions state={state}  fuelType={state.Assessment3bFuelTypesStatus.NaturalGas} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3bStepsEnum.AccountMatchingFuelOil &&
              <div>
                  <p>
                      <strong><u>Step 5b:</u>  Results –  Fuel Oil Households</strong>
                  </p>
                  <Assessment3bTopParagraph state={state}  fuelType={state.Assessment3bFuelTypesStatus.FuelOil} />
                  <Assessment3bMainTable  fieldChangeHandler={state.assessment3bFieldChangeHandler}
                                          holder={state.Assessment3bFuelTypesStatus}
                                          step={state.Assessment3bSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment3bQuestions state={state}  fuelType={state.Assessment3bFuelTypesStatus.FuelOil} />
                  <br />
              </div>
          }

          {state.CurrentAssessementStepIndex == Assessment3bStepsEnum.AccountMatchingPropane &&
              <div>
                  <p>
                      <strong><u>Step 5c:</u>  Results –  Propane Households</strong>
                  </p>
                  <Assessment3bTopParagraph state={state}  fuelType={state.Assessment3bFuelTypesStatus.Propane} />
                  <Assessment3bMainTable  fieldChangeHandler={state.assessment3bFieldChangeHandler}
                                          holder={state.Assessment3bFuelTypesStatus}
                                          step={state.Assessment3bSteps[state.CurrentAssessementStepIndex]}
                                          state={state} />
                  <TableLegendLeft />
                  <Assessment3bQuestions state={state}  fuelType={state.Assessment3bFuelTypesStatus.Propane} />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment3bStepsEnum.ActionPlanSummary &&
              <div>
                  <p>
                      <strong><u>Step 6:</u> Aggregated Action Plan </strong>
                  </p>
                  <p>
                      Congratulations! You have reached the end of Assessment #3B. Your aggregated  
                      action plan for every issue identified in Assessment #3B is included in the  
                      table below. You can now download or print the Assessment #3B action plan  
                      below. Also, you can revisit this page at any time by selecting it from the  
                      list of completed assessments on the Assessment Tool Selection Page.
                  </p>
                  <table id="tblDataReliabilityActionPlan">
                      <thead>
                        <tr>
                            <th>Fuel</th>
                            <th>Issue</th>
                            <th>Action Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                      {state.assessment3bGetFuelTypesArray().map(fuel => {
                          return (
                              <React.Fragment>
                                  {!(state.showActionPlan(fuel))
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td colSpan={2}>N/A</td>
                                  </tr>}
                                  {(state.showActionPlan(fuel))
                                  &&
                                  <React.Fragment>
                                      {(fuel.appVendorNameAndAccountNoDesc !== null 
                                        && fuel.appVendorNameAndAccountNoDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                You must acquire electric billing data on households that heat with fuels other than electricity.</td>
                                            <td>
                                                {fuel.appVendorNameAndAccountNoDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.clientWaiversMeetElectricVendorRequirementsDesc !== null 
                                        && fuel.clientWaiversMeetElectricVendorRequirementsDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                Communicate with your vendors to ensure your waivers meet their requirements.</td>
                                            <td>
                                                {fuel.clientWaiversMeetElectricVendorRequirementsDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.electricVendorRequestedServeTargetPercentHhDesc !== null 
                                        && fuel.electricVendorRequestedServeTargetPercentHhDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                Keep track of the number of LIHEAP clients served by each vendor and each vendor’s compliance history.</td>
                                            <td>
                                                {fuel.electricVendorRequestedServeTargetPercentHhDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.electricVendorProvidedServeTargetPercentHhDesc !== null 
                                        && fuel.electricVendorProvidedServeTargetPercentHhDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                You must request data from vendors representing more than enough clients</td>
                                            <td>
                                                {fuel.electricVendorProvidedServeTargetPercentHhDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.electricBillingDataTargetPercentHhDesc !== null 
                                        && fuel.electricBillingDataTargetPercentHhDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                You must request data from vendors representing more than enough clients so that vendors representing enough clients will comply. </td>
                                            <td>
                                                {fuel.electricBillingDataTargetPercentHhDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.vendorsSupplyDataNonElectricHhDesc !== null 
                                        && fuel.vendorsSupplyDataNonElectricHhDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                You must acquire electric billing data on households that heat with fuels other than electricity.</td>
                                            <td>
                                                {fuel.vendorsSupplyDataNonElectricHhDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.otherReasonMainHeatDesc !== null 
                                        && fuel.otherReasonMainHeatDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                <span>Other reasons for your potential data reliability issue</span>
                                            </td>
                                            <td>
                                                {fuel.otherReasonMainHeatDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.clientWaiversMeetHeatVendorRequirementsDesc !== null 
                                        && fuel.clientWaiversMeetHeatVendorRequirementsDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                For   {fuel.description}   vendors to send you billing data, they must receive satisfactory privacy waivers.</td>
                                            <td>
                                                {fuel.clientWaiversMeetHeatVendorRequirementsDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.heatVendorRequestedServeTargetPercentHhDesc !== null 
                                        && fuel.heatVendorRequestedServeTargetPercentHhDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                If you do not request data on more than  {fuel.targetPercentHouseholdsCoveredString}   of households, you cannot acquire data that meets this threshold.</td>
                                            <td>
                                                {fuel.heatVendorRequestedServeTargetPercentHhDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.heatVendorProvidedServeTargetPercentHhDesc !== null 
                                        && fuel.heatVendorProvidedServeTargetPercentHhDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                You must request data from vendors representing more than enough clients so that vendors representing enough clients will comply.</td>
                                            <td>
                                                {fuel.heatVendorProvidedServeTargetPercentHhDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.heatBillingDataTargetPercentHhDesc !== null 
                                        && fuel.heatBillingDataTargetPercentHhDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                Compliant vendors are not supplying complete data on enough clients.</td>
                                            <td>
                                                {fuel.heatBillingDataTargetPercentHhDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.heatBillingDataIncluesAcctNoDesc !== null 
                                        && fuel.heatBillingDataIncluesAcctNoDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                You must know the main heating vendor and account number of each LIHEAP participating household</td>
                                            <td>
                                                {fuel.heatBillingDataIncluesAcctNoDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.electricBillingDataIncluesAcctNoDesc !== null 
                                        && fuel.electricBillingDataIncluesAcctNoDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                 You must know the electric vendor and account number of each LIHEAP participating household</td>
                                            <td>
                                                {fuel.electricBillingDataIncluesAcctNoDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.hhUniqueIdAssignedDesc !== null 
                                        && fuel.hhUniqueIdAssignedDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                If you cannot match this data to clients, you will not have accurate estimates of the energy expenditures of LIHEAP participating households.</td>
                                            <td>
                                                {fuel.hhUniqueIdAssignedDesc}
                                            </td>
                                        </tr>}
                                      {(fuel.otherReasonMatchingDesc !== null 
                                        && fuel.otherReasonMatchingDesc!== '')
                                        &&
                                        <tr>
                                            <td>{fuel.description}</td>
                                            <td>
                                                {(fuel.hhDataReceivedStatus3b !== Assessment3bDataReceivedStatusEnum.NeitherOverTarget)
                                                &&<span>Other potential explanations for this discrepancy.</span>}
                                                {(fuel.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NeitherOverTarget)
                                                &&<span>Please complete assessments 2 and 3 of the Main Heating Tool and Assessment 2A, 2B, and 3A of the Electric Baseload Tool to learn more.</span>}
                                            </td>
                                            <td>
                                                {fuel.otherReasonMatchingDesc}
                                            </td>
                                        </tr>}
                                  </React.Fragment>
                                  }
                              </React.Fragment>
                          )
                      })}
                      </tbody>
                  </table>
              </div>
          }
          <br />
          
          
          <button className="dataButton"
              onClick={() => state.assessment3bShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment3bStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment3bShowNextStep()}
                  disabled={state.Assessment3bShowNextStepDisabled === true}>
                  Next
              </button>
          }
          {state.CurrentAssessementStepIndex < Assessment3bStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment3bShowActionPlan()}
                  disabled={state.Assessment3bShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }
          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment3bStepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment3bStepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>
          {state.CurrentAssessementStepIndex === Assessment3bStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          {state.CurrentAssessementStepIndex == Assessment3bStepsEnum.ActionPlanSummary
          &&
            <Assessment3bDownloadCSV fuelTypes={[state.Assessment3bFuelTypesStatus.NaturalGas, state.Assessment3bFuelTypesStatus.FuelOil, state.Assessment3bFuelTypesStatus.Propane]}/>
          }
          <div style={{clear:"both"}}>&nbsp;</div>
      </div>
    );

export default Assessment3b;
